/**
 * @generated SignedSource<<e75c31215f9e68233f0d559f9fae5378>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type DatasetVersionCardFragment$data = {
  readonly createdAt: DateTime;
  readonly dataset: {
    readonly id: string;
    readonly owner: {
      readonly username: string;
      readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
    };
    readonly slug: string;
  };
  readonly id: string;
  readonly publishedAt: DateTime | null | undefined;
  readonly size: number;
  readonly updatedAt: DateTime;
  readonly version: Semver;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionPublishButtonFragment">;
  readonly " $fragmentType": "DatasetVersionCardFragment";
};
export type DatasetVersionCardFragment$key = {
  readonly " $data"?: DatasetVersionCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionCardFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DatasetVersionCardFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "size",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dataset",
      "kind": "LinkedField",
      "name": "dataset",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "username",
              "storageKey": null
            },
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "thumbnail",
                  "value": true
                }
              ],
              "kind": "FragmentSpread",
              "name": "EntityProfilePicFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DatasetVersionPublishButtonFragment"
    }
  ],
  "type": "DatasetVersion",
  "abstractKey": null
};
})();

(node as any).hash = "3ac7cdc525d467d44c018ba129aa195d";

export default node;
